<nav class="navbar navbar-default">
    <div class="logo">
        <a class="simple-text">
            <!--[routerLink]="['/niches']"-->
            <div class="logo-img">
                <!--<img src="/assets/img/angular2-logo-white.png" />-->
                <img src="/assets/img/EnergyLeadershiplogoEdited.png" />
            </div>
            <!--<span>ELI</span>-->
        </a>
    </div>
</nav>

<router-outlet></router-outlet>